import React from "react";
import "./Future.css";

function Future(){
    return(
        <div className="future">
            <span className="future-title">...Will be adding more <span style={{color:"#ffcb74"}}><i>div</i></span> </span>
                <div className="code-start-end code-start">.to &#123;</div>
                    <div className="code-content">display: flex;</div>
                <div className="code-start-end">&#125;</div>
                
        </div>
    );
}

export default Future;